import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { swalSuccess, swalError } from '../utils/alert';
import './FormPage.css'; // Assuming a generic form styling

const ResetPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [token, setToken] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const emailParam = params.get('email');
    const tokenParam = params.get('token');

    if (emailParam) setEmail(emailParam);
    if (tokenParam) setToken(tokenParam);
  }, [location]);

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (password !== passwordConfirmation) {
      swalError('As senhas não coincidem.');
      return;
    }

    try {
      const response = await fetch('/api/reset-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          email,
          password,
          password_confirmation: passwordConfirmation,
          token,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        await swalSuccess(data.message + ' Você será redirecionado para a tela de login.');
        navigate('/login');
      } else {
        // Erros de validação (422) retornam data.errors com campos
        if (data.errors) {
          const firstError = Object.values(data.errors)[0];
          swalError(Array.isArray(firstError) ? firstError[0] : firstError);
        } else {
          swalError(data.message || 'Erro ao redefinir a senha.');
        }
      }
    } catch (err) {
      swalError('Erro de rede. Tente novamente mais tarde.');
    }
  };

  return (
    <div className="form-page-container">
      <form onSubmit={handleResetPassword} className="form-card">
        <h2>Redefinir Senha</h2>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="seu@email.com"
            required
            readOnly // Email should be pre-filled from URL
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Nova Senha</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Nova Senha"
            required
            minLength="10"
          />
        </div>
        <div className="form-group">
          <label htmlFor="passwordConfirmation">Confirme a Nova Senha</label>
          <input
            type="password"
            id="passwordConfirmation"
            value={passwordConfirmation}
            onChange={(e) => setPasswordConfirmation(e.target.value)}
            placeholder="Confirme a Nova Senha"
            required
            minLength="10"
          />
        </div>
        <button type="submit" className="submit-button">Redefinir Senha</button>
      </form>
    </div>
  );
};

export default ResetPasswordPage;
